<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },
  color: {
    type: String,
    default: '#80BD1C'
  }
})

const width = computed(() => props.height)
const color = computed(() => props.color);
</script>

<template>
  <svg :width=width :height=height xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <title>Money_order</title>
    <g id="Money_order" :fill=color>
      <rect x="77.68" y="413.66" width="12.39" height="10"/>
      <rect x="199.38" y="292.04" width="142.74" height="10"/>
      <rect x="177.85" y="292.04" width="11.44" height="10"/>
      <rect x="177.85" y="344.59" width="93.39" height="10"/>
      <rect x="323.7" y="318.31" width="18.42" height="10"/>
      <rect x="177.85" y="318.31" width="132.96" height="10"/>
      <rect x="401.28" y="297.04" width="10" height="36.34"/>
      <polygon
        points="411.28 231.86 48.38 231.86 48.38 404.49 339.58 404.49 339.58 394.49 58.38 394.49 58.38 241.86 401.28 241.86 401.28 282.51 411.28 282.51 411.28 231.86"/>
      <polygon
        points="60.54 172.69 66.79 201.9 76.57 199.81 72.41 180.38 447.23 100.21 473.05 220.93 431.02 229.92 431.02 212.69 300.75 212.69 386.68 194.31 384.59 184.53 252.93 212.69 100.46 212.69 96.63 194.8 431.94 123.08 440.45 162.84 450.23 160.75 439.63 111.21 84.76 187.12 90.23 212.69 27.71 212.69 27.71 423.66 64.34 423.66 64.34 413.66 37.71 413.66 37.71 222.69 421.02 222.69 421.02 346.12 359.13 346.12 359.13 391.88 369.13 391.88 369.13 356.12 414.65 356.12 361.93 413.66 102.94 413.66 102.94 423.66 366.33 423.66 431.02 353.07 431.02 240.14 468.8 232.06 437.29 284.71 445.87 289.84 484.29 225.65 454.92 88.34 60.54 172.69"/>
      <rect x="447.18" y="175.6" width="10" height="36.34"
            transform="matrix(0.98, -0.21, 0.21, 0.98, -30.53, 98.85)"/>
      <path
        d="M116.93,313.18h-.34V292.27H137.2v-10H116.59v-20.2h-10v20.2h-.49a20.46,20.46,0,1,0,0,40.91h.49v22.27H85.14v10h21.45v18.82h10V355.45h.34a21.14,21.14,0,1,0,0-42.27Zm-10.83,0a10.46,10.46,0,1,1,0-20.91h.49v20.91Zm10.83,32.27h-.34V323.18h.34a11.14,11.14,0,1,1,0,22.27Z"/>
    </g>
  </svg>
</template>

<style scoped lang="less">

</style>
